export default class ReportsUsageService {
    constructor($http, appConfig) {
      "ngInject";
  
      this._$http = $http;
      this._appConfig = appConfig
    }
  
    getReportsBreakdownByBrand(criteria) {
      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/GetReportsBreakdownByBrand/', criteria);
    }   

    getReportsBreakdownByLocation(criteria) {
        return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbylocation/', criteria);
    }   
    
    getReportsBreakdownByType(criteria) {
        return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbytype/', criteria);
    }       

    getReportsBreakdownByOutputType(criteria) {
        return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbyoutputtype/', criteria);
    }           

    getReportsBreakdownBySalesPerson(criteria) {
        return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbysalesperson/', criteria);
    }               
  }
  


// WEBPACK FOOTER //
// ./client/app/components/reports/adminReports/reportsUsage/reportsUsage.service.js